import { Link } from "react-router"

export function NotFoundPage() {
  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: "100vh", textAlign: "center" }}>
      <div>
        <h1 style={{ fontSize: "var(--text-4xl)" }}>404</h1>
        <p style={{ color: "var(--text-muted)", marginBottom: "var(--space-4)" }}>No encontramos esa página.</p>
        <Link to="/">Volver al inicio</Link>
      </div>
    </div>
  )
}
